"use client";

import { clsx } from "@trydig/ui";
import { Suspense, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { AddToCartMicroCart } from "~/components/ui/AddToCartButton/variant/AddToCartMicroCart";
import { Skeleton } from "~/components/ui/Skeleton";
import { selectors, useMicrocartStore } from "~/features/cart/MicroCart/MicroCartContext";
import styles from "./MicroCart.module.css";

const UnsuspendedMicroCart = () => {
	const [ref, inView] = useInView();

	const [hasMounted, setHasMounted] = useState(false);
	useEffect(() => {
		setHasMounted(true);
	}, []);

	const carts = useMicrocartStore(selectors.cartsArray);
	const allColorVariantYarnsSoldOut = useMicrocartStore(
		(state) => state.allColorVariantYarnsSoldOut,
	);

	if (!hasMounted) {
		return (
			<section data-layout="section">
				<div className={clsx("pdp-card", styles.container)}>
					<p className="pdp-sub-container-title">Oppsummering</p>
					<div>
						<div className={clsx("pdp-sub-container", styles["cart-container"])}>
							<Skeleton height="16px" />
							<Skeleton height="16px" />
						</div>
						<div className={clsx("pdp-sub-container", styles["cart-container"])}>
							<Skeleton height="16px" />
							<Skeleton height="16px" />
						</div>
						<div className={clsx("pdp-sub-container", styles["cart-container"])}>
							<Skeleton height="16px" />
							<Skeleton height="16px" />
						</div>
					</div>
					<AddToCartMicroCart />
				</div>
			</section>
		);
	}

	const Carts = () => {
		return (
			<div>
				{carts?.map((cart) => {
					if (!cart?.id) return null;
					return (
						<div className={clsx(styles["cart-container"])} key={cart.id}>
							<p>{cart.id}</p>
							{cart.totalPrice === 0 && cart.id !== "Oppskrift" ? (
								<p className={styles.muted}>Ikke valgt</p>
							) : (
								<p>{cart.totalPrice},-</p>
							)}
						</div>
					);
				})}
			</div>
		);
	};

	return (
		<section className={clsx(styles["sticky-container"])}>
			<div className={clsx("pdp-card", styles.container)}>
				<p className="pdp-sub-container-title">Oppsummering</p>
				<Carts />
				<div ref={ref} className={clsx(styles.addToCartContainer)}>
					<AddToCartMicroCart soldOut={allColorVariantYarnsSoldOut} />
				</div>
			</div>
			<div className={clsx(styles.stickyAddToCart, !inView && styles.shown)}>
				<Carts />
				<div style={{ marginTop: "0.5rem" }}>
					<AddToCartMicroCart soldOut={allColorVariantYarnsSoldOut} />
				</div>
			</div>
		</section>
	);
};

export const MicroCart = () => {
	return (
		<Suspense>
			<UnsuspendedMicroCart />
		</Suspense>
	);
};
